// extracted by mini-css-extract-plugin
export default {"form":"FormCheckedStatus_form__TdhE-","wrapperInputs":"FormCheckedStatus_wrapperInputs__oKbFe"};